function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M0 0.263L96.737 0.263 96.737 97 0 97z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#71F7B2",
  d: "M94 48.5C94 74.181 73.405 95 48 95S2 74.181 2 48.5 22.595 2 48 2s46 20.819 46 46.5"
}), /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#1E1210",
  d: "M48.369 4.748c-24.198 0-43.884 19.686-43.884 43.884 0 24.197 19.686 43.882 43.884 43.882 24.197 0 43.882-19.685 43.882-43.882 0-24.198-19.685-43.884-43.882-43.884m0 92.252C21.699 97-.001 75.302-.001 48.632 0 21.96 21.7.262 48.37.262c26.67 0 48.368 21.698 48.368 48.37C96.737 75.302 75.039 97 48.369 97",
  mask: "url(#prefix__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E1210",
  d: "M75.76 55.942c-.254-.471-.675-.817-1.188-.971l-6.25-1.887c-1.054-.312-2.185.277-2.507 1.333l-.105.344c-.155.51-.102 1.05.15 1.522.254.473.676.818 1.19.972l.98.297c-2.768 8.392-10.968 14.095-20.29 14.095-.19 0-.379-.002-.568-.007-8.696-.215-17.003-6.351-19.216-14.084l.995-.3c1.06-.321 1.66-1.44 1.339-2.494l-.107-.346c-.32-1.055-1.442-1.646-2.507-1.332l-6.248 1.887c-.513.154-.935.5-1.19.972-.252.472-.306 1.011-.151 1.52l.105.349c.324 1.053 1.448 1.65 2.509 1.33l.413-.127c.123-.026.249-.061.375-.098 4.581 10.89 12.406 16.627 23.266 17.056.459.019.91.027 1.36.027 11.307-.001 19.496-5.749 24.362-17.106l.822.248c1.065.322 2.187-.277 2.508-1.331l.106-.347c.155-.51.101-1.05-.153-1.522M34.5 38c3.038 0 5.5-2.463 5.5-5.5 0-3.038-2.462-5.5-5.5-5.5S29 29.462 29 32.5c0 3.037 2.462 5.5 5.5 5.5M61.5 38c3.038 0 5.5-2.463 5.5-5.5 0-3.038-2.462-5.5-5.5-5.5S56 29.462 56 32.5c0 3.037 2.462 5.5 5.5 5.5"
}));

var SvgEmojiSuccess = function SvgEmojiSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmojiSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoji-success.01f9d011.svg";
export { ForwardRef as ReactComponent };